import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ReportChartComponent} from "../types/report.chart.component";
import {useAppStore} from "../../../common/app.store.consumer";

const FeedbackPanel: React.FC<ReportChartComponent> = useAppStore()(({isPdf, appStore}) => {

	return (
		<div className="cih-feedback-bar">
			<div>
				<div className="download-title">Feedback</div>
				<div className="download-details">Let us know what you think about taking the self-assessment</div>
			</div>
			<button className="cih-btn-med cih-align-self-end cih-align-items-center cih-align-self-center"
				onClick={() => window.location.href = `mailto:${appStore.configuration.feedbackEmail}?subject=Feedback on CIH Professional Standards Report`}>
				<FontAwesomeIcon icon={["fas", "user"]}/>
				Feedback
			</button>
		</div>
	);
});

export default FeedbackPanel;
